module.exports = __webpack_public_path__ + "img/c64530c310bf4f50a287bfc125aac82a-1440.c8264e0f.png";